import { CSS } from "../../constants/css";

const instance = ($el: HTMLElement) => {
  const dom = {
    $closeBtns: $el.querySelectorAll<HTMLElement>(".js-search-close-btn"),
    $html: document.documentElement,
    $modal: $el.querySelector<HTMLElement>(".js-search-modal"),
    $modalBackground: $el.querySelector<HTMLElement>(
      ".js-search-modal-background",
    ),
    $modalInput: $el.querySelector<HTMLElement>(".js-search-modal-input"),
    $modalButton: $el.querySelector<HTMLElement>(".js-search-modal-button"),
    $openBtns: $el.querySelectorAll<HTMLElement>(".js-search-open-btn"),
  };

  const checkKeyForClose = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      close();
    }
  };

  const close = () => {
    document.documentElement.removeEventListener("keyup", checkKeyForClose);

    dom.$html.classList.remove(CSS.overflowHidden);
    dom.$modal?.classList.remove(CSS.visible);

    dom.$modalInput?.setAttribute("tabindex", "-1");
    dom.$modalButton?.setAttribute("tabindex", "-1");

    dom.$closeBtns.forEach(($closeBtn) => {
      $closeBtn.setAttribute("tabindex", "-1");
    });
  };

  const open = () => {
    dom.$html.classList.add(CSS.overflowHidden);
    dom.$modal?.classList.add(CSS.visible);

    dom.$modalInput?.focus();
    dom.$modalInput?.removeAttribute("tabindex");
    dom.$modalButton?.removeAttribute("tabindex");

    dom.$closeBtns.forEach(($closeBtn) => {
      $closeBtn.removeAttribute("tabindex");
    });

    document.documentElement.addEventListener("keyup", checkKeyForClose);
    dom.$modalBackground?.addEventListener("click", close);
  };

  dom.$closeBtns.forEach(($closeBtn) => {
    $closeBtn.addEventListener("click", close);
  });

  dom.$openBtns.forEach(($openBtn) => {
    $openBtn.addEventListener("click", open);
  });
};

export default () => {
  const $searches = document.querySelectorAll<HTMLElement>(".js-search");

  $searches.forEach(($element) => {
    instance($element);
  });
};
